var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1486_5261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-129.521 212.564L-200 180V398.182H786.703V245.129L716.224 212.564C671.509 191.904 619.981 191.904 575.267 212.564C530.552 233.225 479.024 233.225 434.309 212.564C389.594 191.904 338.066 191.904 293.351 212.564C248.637 233.225 197.109 233.225 152.394 212.564C107.679 191.904 56.151 191.904 11.4363 212.564C-33.2784 233.225 -84.8065 233.225 -129.521 212.564Z",
    fill: "#28885A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9329 212.564L-54.5459 180V398.182H932.157V245.129L861.678 212.564C816.964 191.904 765.435 191.904 720.721 212.564C676.006 233.225 624.478 233.225 579.763 212.564C535.048 191.904 483.52 191.904 438.806 212.564C394.091 233.225 342.563 233.225 297.848 212.564C253.133 191.904 201.605 191.904 156.89 212.564C112.176 233.225 60.6476 233.225 15.9329 212.564Z",
    fill: "#3CC985"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 195,
    stroke: "#3CC985",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.414 116.666H223.986L209.144 184.219L243.641 196.999V205.73L188.534 283.333H179.962L194.805 215.78L160.308 203V194.269L215.414 116.666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1486_5261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    rx: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.99bb71f68d8f7d3eca399b3191e380e7.svg";
export { ForwardRef as ReactComponent };